import { call, put } from 'redux-saga/effects'
import {
  getInterviewRequestsMessages,
  patchInterviewRequestMessage,
  postInterviewRequestMessage,
} from '../apiModules/interviewRequestMessages'
import { interviewRequestMessageEntities } from '../reducks'

export function* fetchInterviewRequestMessageEntitiesSaga(interviewRequestId, params) {
  const response = yield call(getInterviewRequestsMessages, interviewRequestId, params)
  yield put(interviewRequestMessageEntities.addCollection(response.result))
  return response
}

export function* createInterviewRequestMessageEntitySaga(interviewRequestId, data) {
  const response = yield call(postInterviewRequestMessage, interviewRequestId, data)
  yield put(interviewRequestMessageEntities.addItem(response.result.id, response.result))
  return response
}

// The entity's add-item action merges into the existing message, so an edit needs no separate action.
export function* updateInterviewRequestMessageEntitySaga(interviewRequestId, messageId, data) {
  const response = yield call(patchInterviewRequestMessage, interviewRequestId, messageId, data)
  yield put(interviewRequestMessageEntities.addItem(response.result.id, response.result))
  return response
}
